import ReactDOM from 'react-dom/client';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Provider } from 'react-redux';
import App from './App';
import { AuditLabelProvider } from './components/AuditLabel';
import TranslateProvider from './components/Translate/TranslateProvider';
import './index.css';
import { store } from './store';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const language = window.navigator.languages[0].toLowerCase();

root.render(
  <Provider store={store}>
    <TranslateProvider language={language}>
      <AuditLabelProvider>
        <DndProvider backend={HTML5Backend}>
          <App />
        </DndProvider>
      </AuditLabelProvider>
    </TranslateProvider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
